import { lazy, Suspense } from "react";
import Landing2Banner from "../landingPages/landingTwo/Landing2Banner";

const Landing2Apps = lazy(() => import("../landingPages/landingTwo/Landing2Apps"));
const Landing2Choose = lazy(() => import("../landingPages/landingTwo/Landing2Choose"));
const Landing2Get = lazy(() => import("../landingPages/landingTwo/Landing2Get"));
const Landing2Go = lazy(() => import("../landingPages/landingTwo/Landing2Go"));
const Landing2Launch = lazy(() => import("../landingPages/landingTwo/Landing2Launch"));
const Landing2Market = lazy(() => import("../landingPages/landingTwo/Landing2Market"));
const Landing2Works = lazy(() => import("../landingPages/landingTwo/Landing2Works"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const faqData = [
  {
    id: "0",
    question: "01. What is taxi dispatch software, and how does it work?",
    answer: "Taxi dispatch software is a technology solution that helps companies manage their operations more efficiently. It automates the process of dispatching rides to drivers, tracking vehicle locations, and managing customer bookings. By using a taxi dispatch system, businesses can streamline their operations, improve response times, and enhance customer satisfaction.",
  },
  {
    id: "1",
    question: "02. How can taxi management software benefit my business?",
    answer: "Implementing taxi management software allows you to automate scheduling and tracking, which reduces manual errors and overhead costs. This robust taxi business software also provides deep analytics to help you optimize driver performance and increase overall fleet profitability.",
  },
  {
    id: "2",
    question: "03. Is your taxi dispatch system UK compliant?",
    answer: "Yes, our taxi dispatch system is fully compliant with UK regulations, including GDPR and local licensing requirements. We ensure our software for taxi operations meets all safety and reporting standards necessary for legal compliance in the UK market.",
  },
  {
    id: "3",
    question: "04. Can I integrate ride-sharing management software with my existing systems?",
    answer: "Absolutely. Our software for taxi business is designed for high compatibility, allowing you to integrate our taxi software dispatch tools with your current CRM or accounting platforms via secure APIs.",
  },
  {
    id: "4",
    question: "05. What features should I look for in cab software?",
    answer: "When choosing taxi cab software, you should prioritize real-time GPS tracking, a reliable taxi booking system, and automated dispatching. Additionally, a high-quality white label taxi app should offer secure payment gateways and an easy-to-use interface for both drivers and passengers.",
  },
];

const breadcrumbData = {
  newClass: "center-breadcrumb",
  list: [
    {
      page: "Home",
      slug: "/"
    },
    {
      page: "Taxi Dispatch Software",
      slug: ""
    },
  ]
}

export default function TaxiSoftware() {
  return (
    <>
      <Landing2Banner breadcrumbData={breadcrumbData} />
      <Suspense fallback={null}>
        <Landing2Go />
        <Landing2Market />
        <Landing2Get />
        <Landing2Apps />
        <Landing2Choose />
        <Landing2Works />
        <div className="solution-case">
          <OnDemandWork filterData={"Taxi app"}/>
        </div>
        <section className="land2-testimonial"><ShuttleAppreciation /></section>
        <section className="land2-faq"><TaxiFaq faqData={faqData} /></section>
        <Landing2Launch />
      </Suspense>
    </>
  )
}


// import { Nav, Tab } from "react-bootstrap";
// import { useDispatch } from "react-redux";
// import { Link } from "react-router-dom";
// import { openPopup } from "../../store/popupSlice";
// import ShuttleAppreciation from "../shuttle_software/ShuttleAppreciation";
// import ShuttleItNeed from "../shuttle_software/ShuttleItNeed";
// import TaxiFaq from "../taxiDispatchSoftware/TaxiFaq";

// const faqData = [
//   {
//     id: "0",
//     question: "01. What is taxi dispatch software, and how does it work?",
//     answer:
//       "Taxi dispatch software is a technology solution that helps taxi companies manage their operations more  efficiently. It automates the process of dispatching rides to drivers, tracking vehicle locations, and managing customer bookings. By using a taxi dispatch system, businesses can streamline their operations, improve response times, and enhance customer satisfaction.",
//   },
//   {
//     id: "1",
//     question: "02. How can taxi management software benefit my business?",
//     answer:
//       "Taxi management software provides a comprehensive solution for handling various aspects of a taxi business, including ride bookings, driver management, and fare calculations. With a Taxi Software Solution, you can improve operational efficiency, reduce errors, and gain valuable insights through data analytics. This leads to better decision-making and ultimately drives business growth.",
//   },
//   {
//     id: "2",
//     question: "03. Is your taxi dispatch system UK compliant?",
//     answer:
//       "Yes, our taxi dispatch system is designed to meet the specific regulations and requirements of the UK market. We ensure that our taxi management software adheres to local laws and standards, providing you with a reliable solution for managing your taxi operations while remaining compliant.",
//   },
//   {
//     id: "3",
//     question: "04. Can I integrate ride-sharing management software with my existing systems?",
//     answer:
//       "Absolutely! Our ride-sharing management software is built to be flexible and easily integrated with your current systems. This allows you to enhance your existing operations without starting from scratch. Whether you use a taxi dispatch system or other software solutions, our taxi management software can seamlessly connect to create a unified platform for your business.",
//   },
//   {
//     id: "4",
//     question: "05. What features should I look for in cab software?",
//     answer:
//       "When choosing cab software, consider features such as real-time GPS tracking, automated dispatching, payment processing, customer management, and reporting tools. Our pre-built taxi dispatch software includes all these essential features and more, providing a comprehensive solution to effectively manage your taxi business.",
//   },
// ];

// const taxiSoftwareFeatureId = "taxi-dispatch-software";

// export default function TaxiSoftware() {
//   const dispatch = useDispatch();
//   return (
//     <>

//       <section className="sub-header header-gap" style={{ backgroundImage: "url(../assets/home/taxisolu-banner.webp)" }}>
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-8">
//               <div className="sub-header-content">
//                 <h1 className="heading">Taxi Dispatch Software</h1>
//                 <p>
//                   Revolutionize Your Ride:
//                   <span>Next-Gen Taxi Dispatch System</span> by Mobility
//                   Infotech
//                 </p>
//                 <p>21 Days Free Trial | No Credit Card Required</p>
//               </div>
//             </div>
//             <div className="col-lg-12 text-center mt-4">
//               <Link onClick={() => dispatch(openPopup())} className="default-btn">book free demo</Link>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="taxi-white">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-10">
//               <h2 className="heading center-heading">
//                 White Label Taxi Dispatch Solution
//               </h2>
//               <p>
//                 for seamless business operations. Upgrade your fleet operations
//                 with a powerful <>Taxi Dispatch Software Solution</>,
//                 <>featuring real-time tracking</>,
//                 <> automation, and flexible </>,
//                 <> subscriptions</>
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="interface-area">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-10">
//               <h2 className="heading center-heading">
//                 Taxi / Cab Dispatch Software Tailored
//                 <br /> for Modern Taxi Businesses
//               </h2>
//               <p className="sub-heading">
//                 Streamline Cab & Taxi bookings with our dynamic taxi dispatch
//                 software, offering unmatched scalability for your on-demand
//                 business. Transform your fleet with advanced Taxi Dispatch
//                 Software designed for seamless ride booking. From cab dispatch
//                 systems to taxi business software, streamline operations with
//                 real-time tracking, automated driver assignments, and unmatched
//                 scalability. Flexible taxi monthly subscription options ensure
//                 affordability, making it the go-to solution for growing fleets.
//               </p>
//             </div>
//             <div className="col-lg-12">
//               <div className="interface-tabs">
//                 <Tab.Container id="left-tabs-example" defaultActiveKey="first">
//                   <Nav variant="pills" className="flex-column">
//                     <Nav.Item>
//                       <Nav.Link eventKey="first">customer app</Nav.Link>
//                     </Nav.Item>
//                     <Nav.Item>
//                       <Nav.Link eventKey="second">driver app</Nav.Link>
//                     </Nav.Item>
//                   </Nav>

//                   <Tab.Content>
//                     <Tab.Pane eventKey="first">
//                       <div className="interface-tab-body">
//                         <div className="row">
//                           <div className="col-lg-4 col-md-4">
//                             <div className="tab-content-box">
//                               <h3>Book Rides Instantly</h3>
//                               <p>
//                                 Instant, seamless scheduling at your fingertips.
//                                 Enjoy quick, reliable transportation with just a
//                                 tap
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Schedule Booking</h3>
//                               <p>
//                                 Schedule rides effortlessly—plan ahead with ease
//                                 and enjoy reliable transportation on your terms
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Notification Alerts</h3>
//                               <p>
//                                 Stay informed with instant notification
//                                 alerts—never miss an update on your ride.
//                               </p>
//                             </div>
//                           </div>

//                           <div className="col-lg-4 col-md-4">
//                             <div className="taxitab-mobile">
//                               <img
//                                 src="./assets/home/interface-tab-img1.webp"
//                                 alt="app"
//                                 className="img-responsive"
//                                 loading="lazy"
//                                 width="100%" height="100%"
//                               />
//                               <div className="taxitab-wave"></div>
//                             </div>
//                           </div>

//                           <div className="col-lg-4 col-md-4">
//                             <div className="tab-content-box">
//                               <h3>Driver Tracking</h3>
//                               <p>
//                                 Track your driver in real-time—stay updated on
//                                 their location and arrival.
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Know your Driver</h3>
//                               <p>
//                                 Get to know your driver—view profiles and
//                                 ratings before you ride.
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Seamless Payments</h3>
//                               <p>
//                                 Enjoy seamless payments—fast, secure, and
//                                 hassle-free transactions.
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </Tab.Pane>

//                     <Tab.Pane eventKey="second">
//                       <div className="interface-tab-body">
//                         <div className="row">
//                           <div className="col-lg-4 col-md-4">
//                             <div className="tab-content-box">
//                               <h3>Book Rides Instantly</h3>
//                               <p>
//                                 Instant, seamless scheduling at your fingertips.
//                                 Enjoy quick, reliable transportation with just a
//                                 tap
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Schedule Booking</h3>
//                               <p>
//                                 Schedule rides effortlessly—plan ahead with ease
//                                 and enjoy reliable transportation on your terms
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Notification Alerts</h3>
//                               <p>
//                                 Stay informed with instant notification
//                                 alerts—never miss an update on your ride.
//                               </p>
//                             </div>
//                           </div>

//                           <div className="col-lg-4 col-md-4">
//                             <div className="taxitab-mobile">
//                               <img
//                                 src="./assets/home/interface-tab-img.webp"
//                                 alt="app"
//                                 className="img-responsive"
//                                 loading="lazy"
//                                 width="100%" height="100%"
//                               />
//                               <div className="taxitab-wave"></div>
//                             </div>
//                           </div>

//                           <div className="col-lg-4 col-md-4">
//                             <div className="tab-content-box">
//                               <h3>Driver Tracking</h3>
//                               <p>
//                                 Track your driver in real-time—stay updated on
//                                 their location and arrival.
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Know your Driver</h3>
//                               <p>
//                                 Get to know your driver—view profiles and
//                                 ratings before you ride.
//                               </p>
//                             </div>
//                             <div className="tab-content-box">
//                               <h3>Seamless Payments</h3>
//                               <p>
//                                 Enjoy seamless payments—fast, secure, and
//                                 hassle-free transactions.
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </Tab.Pane>
//                   </Tab.Content>
//                 </Tab.Container>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <h2 className="heading center-heading">
//                 USP's - Smart IT Delivery Benefits
//               </h2>
//             </div>

//             <div className="col-lg-12">
//               <div className="uspbenefit-row">
//                 <div
//                   className="uspbenefit-box wow animate__animated animate__fadeInUp"
//                   data-wow-duration="1s"
//                   data-wow-delay="0.1s"
//                 >
//                   <img
//                     src="./assets/home/usp-icon-1.webp"
//                     alt="icon"
//                     loading="lazy"
//                   />
//                   <h3>Latest Tech Stack</h3>
//                   <p>
//                   Our taxi dispatch software leverages advanced technology, including GPS integration, cloud computing, real-time data analytics, and automation for efficient operations.
//                   </p>
//                 </div>

//                 <div className="uspbenefit-image">
//                   <img
//                     src="./assets/home/uspbenefit-1.webp"
//                     className="img-responsive"
//                     alt="Benefit"
//                     loading="lazy"
//                     width="100%" height="100%"
//                   />
//                 </div>
//               </div>

//               <div className="uspbenefit-row uspbenefit-reverse">
//                 <div
//                   className="uspbenefit-box wow animate__animated animate__fadeInUp"
//                   data-wow-duration="1s"
//                   data-wow-delay="0.1s"
//                 >
//                   <img
//                     src="./assets/home/usp-icon-2.webp"
//                     alt="icon"
//                     loading="lazy"
//                   />
//                   <h3>User-Friendly UI/UX</h3>
//                   <p>
//                   Our taxi dispatch software features a user-friendly interface with intuitive navigation, responsive design, and seamless functionality for effortless operations.
//                   </p>
//                 </div>

//                 <div className="uspbenefit-image">
//                   <img
//                     src="./assets/home/uspbenefit-2.webp"
//                     className="img-responsive"
//                     alt="Benefit"
//                     loading="lazy"
//                     width="100%" height="100%"
//                   />
//                 </div>
//               </div>

//               <div className="uspbenefit-row">
//                 <div
//                   className="uspbenefit-box wow animate__animated animate__fadeInUp"
//                   data-wow-duration="1s"
//                   data-wow-delay="0.1s"
//                 >
//                   <img
//                     src="./assets/home/usp-icon-3.webp"
//                     alt="icon"
//                     loading="lazy"
//                   />
//                   <h3>Customizable for SAAS Products</h3>
//                   <p>
//                   Our taxi dispatch software is fully customizable for SaaS products, offering flexible features, scalable modules, and seamless integration tailored to your needs.
//                   </p>
//                 </div>

//                 <div className="uspbenefit-image">
//                   <img
//                     src="./assets/home/uspbenefit-3.webp"
//                     className="img-responsive"
//                     alt="Benefit"
//                     loading="lazy"
//                     width="100%" height="100%"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="taxi-operation-area">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <h2 className="heading center-heading">
//                 {/* Keep a Close Look at all your Operations */}
//                 Track Every Aspect of Your Taxi Business Software Seamlessly
//               </h2>
//               <p className="sub-heading">
//                 With our taxi dispatch system, ensure smooth operations at every
//                 step. Our software for taxi business is built to support growth
//                 and scalability,
//                 <br /> no matter the size of your fleet or business stage.
//               </p>
//             </div>
//             <div className="col-lg-12">
//               <Tab.Container
//                 id="left-tabs-example"
//                 defaultActiveKey="first-operation"
//               >
//                 <div className="row operation-tab-row">
//                   <div className="col-lg-5 col-md-6">
//                     <Nav variant="pills" className="flex-column">
//                       <Nav.Item>
//                         <Nav.Link eventKey="first-operation">
//                           <div className="operation-box">
//                             <label>01</label>
//                             <h3>Manage Bookings</h3>
//                             <p>
//                               Effortlessly manage and streamline all taxi
//                               bookings with our cab software.
//                             </p>
//                           </div>
//                         </Nav.Link>
//                       </Nav.Item>
//                       <Nav.Item>
//                         <Nav.Link eventKey="second-operation">
//                           <div className="operation-box">
//                             <label>02</label>
//                             <h3>Surge Pricing</h3>
//                             <p>
//                               Automatically adjust fares with dynamic surge
//                               pricing to maximise revenue.
//                             </p>
//                           </div>
//                         </Nav.Link>
//                       </Nav.Item>
//                       <Nav.Item>
//                         <Nav.Link eventKey="third-operation">
//                           <div className="operation-box">
//                             <label>03</label>
//                             <h3>Manage Drivers</h3>
//                             <p>
//                               Efficiently oversee and coordinate your drivers
//                               with our management tools.
//                             </p>
//                           </div>
//                         </Nav.Link>
//                       </Nav.Item>
//                       <Nav.Item>
//                         <Nav.Link eventKey="fourth-operation">
//                           <div className="operation-box">
//                             <label>04</label>
//                             <h3>Offer Promotions</h3>
//                             <p>
//                               Create and manage promotions to attract and retain
//                               customers effortlessly.
//                             </p>
//                           </div>
//                         </Nav.Link>
//                       </Nav.Item>
//                     </Nav>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <Tab.Content>
//                       <Tab.Pane eventKey="first-operation">
//                         <img
//                           src="./assets/home/landing-taxi-operation-img2.webp"
//                           alt="operation"
//                           className="img-responsive tab-img-operation"
//                           loading="lazy"
//                         />
//                       </Tab.Pane>
//                       <Tab.Pane eventKey="second-operation">
//                         <img
//                           src="./assets/home/landing-taxi-operation-img1.webp"
//                           alt="operation"
//                           className="img-responsive tab-img-operation"
//                           loading="lazy"
//                         />
//                       </Tab.Pane>
//                       <Tab.Pane eventKey="third-operation">
//                         <img
//                           src="./assets/home/landing-taxi-operation-img3.webp"
//                           alt="operation"
//                           className="img-responsive tab-img-operation"
//                           loading="lazy"
//                         />
//                       </Tab.Pane>
//                       <Tab.Pane eventKey="fourth-operation">
//                         <img
//                           src="./assets/home/landing-taxi-operation-img4.webp"
//                           alt="operation"
//                           className="img-responsive tab-img-operation"
//                           loading="lazy"
//                         />
//                       </Tab.Pane>
//                     </Tab.Content>
//                   </div>
//                 </div>
//               </Tab.Container>
//             </div>
//           </div>
//         </div>
//       </section>

//       <div className="taxi-launch">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-9">
//               <h2 className="heading">
//                 Kickstart, Expand, and Thrive with Your Online Taxi Business!
//               </h2>
//               <p>
//                 Empower your operations with cutting-edge taxi dispatch software
//                 designed for seamless customer experiences and efficient
//                 processes. Whether you're looking for reliable taxi business
//                 software, a cab dispatch system, or a taxi dispatch system, our
//                 ride sharing software solutions ensure smooth management with
//                 flexible taxi monthly subscription plans. Elevate your business
//                 with software tailored to the needs of the modern cab industry!
//               </p>
//               <Link
//                 onClick={() => dispatch(openPopup())}
//                 className="default-white"
//               >
//                 Get in touch
//               </Link>
//             </div>
//           </div>
//         </div>

//         <div className="taxilaunch-car-1">
//           <img
//             src="./assets/home/taxicar-1.webp"
//             className="wow animate__animated animate__slideInLeft"
//             data-wow-delay="0.1s"
//             data-wow-duration="1s"
//             alt="car"
//             loading="lazy"
//           />
//         </div>

//         <div className="taxilaunch-car-2">
//           <img
//             src="./assets/home/taxicar-2.webp"
//             className="wow animate__animated animate__slideInRight"
//             data-wow-delay="0.1s"
//             data-wow-duration="1s"
//             alt="car"
//             loading="lazy"
//           />
//         </div>
//       </div>

//       <div className="taxitech-area">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <h2 className="heading center-heading">
//                 Elevate Dispatch Operations with Industry-Leading Taxi Software.
//               </h2>
//               <p className="sub-heading">
//               Our robust, high-load backend infrastructure ensures secure payments and seamless operations. Specifically designed for cab dispatch software and taxi software, our advanced system processes millions of hits daily, is trusted by enterprise clients, and delivers unmatched reliability.
//               </p>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <div className="taxitech-box">
//                 <img
//                   src="./assets/home/taxitech-1.webp"
//                   className="img-responsive"
//                   alt="technology"
//                   loading="lazy"
//                 />
//                 <div>
//                   <h3>Driver Intelligence</h3>
//                   <p>
//                     Boost efficiency with Driver Intelligence—optimize
//                     performance and routes with real-time data and advanced
//                     analytics.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <div className="taxitech-box">
//                 <img
//                   src="./assets/home/taxitech-2.webp"
//                   className="img-responsive"
//                   alt="technology"
//                   loading="lazy"
//                 />
//                 <div>
//                   <h3>Integration</h3>
//                   <p>
//                     Seamless integration—easily connect with existing systems to
//                     enhance functionality and streamline operations.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <div className="taxitech-box">
//                 <img
//                   src="./assets/home/taxitech-3.webp"
//                   className="img-responsive"
//                   alt="technology"
//                   loading="lazy"
//                 />
//                 <div>
//                   <h3>Cloud Hosting</h3>
//                   <p>
//                     Scalable cloud hosting—reliable, flexible, and secure
//                     infrastructure for your needs.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <div className="taxitech-box">
//                 <img
//                   src="./assets/home/taxitech-4.webp"
//                   className="img-responsive"
//                   alt="technology"
//                   loading="lazy"
//                 />
//                 <div>
//                   <h3>Smart Geolocation</h3>
//                   <p>
//                     Smart geolocation—deliver precise, real-time tracking for
//                     optimized routes and superior service, ensuring efficiency
//                     and accuracy at every turn.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <ShuttleAppreciation />

//       <div className="taxi-ondemand">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-12">
//               <h2 className="heading">
//               Building Your On-Demand Business Made Easy with Mobility Infotech
//               </h2>

//               <Link
//                 onClick={() => dispatch(openPopup())}
//                 className="default-white"
//               >
//                 schedule a call
//               </Link>
//             </div>
//           </div>
//         </div>

//         <div className="taxiondemand-car-1">
//           <img
//             src="./assets/home/ondemand-taxicar-1.webp"
//             className="wow animate__animated animate__slideInLeft"
//             data-wow-delay="0.1s"
//             data-wow-duration="1s"
//             alt="car"
//             loading="lazy"
//           />
//         </div>

//         <div className="taxiondemand-car-2">
//           <img
//             src="./assets/home/ondemand-taxicar-2.webp"
//             className="wow animate__animated animate__slideInRight"
//             data-wow-delay="0.1s"
//             data-wow-duration="1s"
//             alt="car"
//             loading="lazy"
//           />
//         </div>
//       </div>

//       <ShuttleItNeed featureId={taxiSoftwareFeatureId} />

//       <TaxiFaq faqData={faqData}/>
//     </>
//   );
// }